import dayjs from "dayjs"

const conversionProbabilityTransformer = (response, month) => {
  const fillMissingDates = (data, dateKey, lastKnownData, conversionType) => {
    if (!data?.length) {
      return []
    }
    let filledData = []

    const selectedMonthStart = dayjs().month(month).startOf("month")
    const selectedMonthEnd = dayjs().month() === month ? dayjs().endOf("day") : dayjs().month(month).endOf("month")

    const formatDate = d => dayjs(d).format("YYYY-MM-DD")
    let currentDate = selectedMonthStart
    let dataIndex = 0

    let lastKnown =
      dayjs(data?.[0]?.[dateKey]).year() === 1970
        ? { ...lastKnownData, [dateKey]: formatDate(selectedMonthStart) }
        : { ...data[0], [dateKey]: formatDate(selectedMonthStart) }

    filledData.push({ ...lastKnown })
    currentDate = currentDate.add(1, "day")
    dataIndex += 1

    while (currentDate.isSameOrBefore(selectedMonthEnd, "day")) {
      const currentDateStr = formatDate(currentDate)
      let dataItem = data[dataIndex]
      const dataDateStr = dataItem ? formatDate(dataItem[dateKey]) : null

      if (dataDateStr === currentDateStr) {
        const clonedItem = structuredClone(dataItem)
        clonedItem[dateKey] = currentDateStr
        lastKnown = clonedItem
        filledData.push(clonedItem)
        dataIndex++
      } else if (lastKnown) {
        if (conversionType === "ai") {
          const { analysis } = lastKnown
          const aiClone = { analysis, [dateKey]: currentDateStr }
          filledData.push(aiClone)
        } else {
          const clone = structuredClone(lastKnown)
          clone[dateKey] = currentDateStr
          filledData.push(clone)
        }
      }

      currentDate = currentDate.add(1, "day")
    }
    return filledData
  }

  return {
    staffConversionData: fillMissingDates(
      response?.staffConversionInformation,
      "updatedAt",
      {
        updatedAt: dayjs().month(month).endOf("month"),
        conversionProbability: 0,
      },
      "staff"
    ),
    aiConversionData: fillMissingDates(
      response?.data,
      "analysisDate",
      response?.data?.[0]?.analysis
        ? response?.data?.[0]
        : {
            analysisDate: dayjs().month(month).endOf("month"),
            analysis: { metrics: [], closure_probability: 0 },
          },
      "ai"
    ),
  }
}

export default conversionProbabilityTransformer
